var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivilegeGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 15,
    viewBox: "0 0 32 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36364 10.1436L7.03636 11.7691L6.32727 8.70364L8.72727 6.65273L5.57455 6.38L4.36364 3.5L3.13091 6.38L0 6.65273L2.37818 8.70364L1.63636 11.7691L4.36364 10.1436Z",
    fill: "#5C5D6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C20.9283 0.5 21.8185 0.868749 22.4749 1.52513C23.1313 2.1815 23.5 3.07174 23.5 4C23.5 4.92826 23.1313 5.8185 22.4749 6.47487C21.8185 7.13125 20.9283 7.5 20 7.5C19.0717 7.5 18.1815 7.13125 17.5251 6.47487C16.8687 5.8185 16.5 4.92826 16.5 4C16.5 3.07174 16.8687 2.1815 17.5251 1.52513C18.1815 0.868749 19.0717 0.5 20 0.5V0.5ZM13 3C13.56 3 14.08 3.15 14.53 3.42C14.38 4.85 14.8 6.27 15.66 7.38C15.16 8.34 14.16 9 13 9C12.2044 9 11.4413 8.68393 10.8787 8.12132C10.3161 7.55871 10 6.79565 10 6C10 5.20435 10.3161 4.44129 10.8787 3.87868C11.4413 3.31607 12.2044 3 13 3V3ZM27 3C27.7956 3 28.5587 3.31607 29.1213 3.87868C29.6839 4.44129 30 5.20435 30 6C30 6.79565 29.6839 7.55871 29.1213 8.12132C28.5587 8.68393 27.7956 9 27 9C25.84 9 24.84 8.34 24.34 7.38C25.2 6.27 25.62 4.85 25.47 3.42C25.92 3.15 26.44 3 27 3ZM13.5 13.25C13.5 11.18 16.41 9.5 20 9.5C23.59 9.5 26.5 11.18 26.5 13.25V15H13.5V13.25ZM8 15V13.5C8 12.11 9.89 10.94 12.45 10.6C11.86 11.28 11.5 12.22 11.5 13.25V15H8ZM32 15H28.5V13.25C28.5 12.22 28.14 11.28 27.55 10.6C30.11 10.94 32 12.11 32 13.5V15Z",
    fill: "#5C5D6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivilegeGroups);
export default __webpack_public_path__ + "static/media/privilege-groups.b74386fdd3cf54ee9cdc7be78032d568.svg";
export { ForwardRef as ReactComponent };